import React, {useEffect} from 'react'
import PropTypes from 'prop-types'

/* Utils */
import {
    Box
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Components */
import Field from '../field'

/* Fields */
import useNewsletterSignUp from './useNewsletterSignUp'

const NewsletterSignUpFields = ({
    form,
    prefix = '',
    ...otherProps
}) => {
    const fields = useNewsletterSignUp({form, prefix})

    const handleOnEmailChange = (e) => {
        if (e.target.value === '') {
            form.reset()
        }

        form.setValue(`${prefix}newsletterEmail`, e.target.value)
    }

    return (
        <Box>
            <Field
                {...fields?.newsletterEmail}
                inputProps={{
                    ...otherProps,
                    onBlur: handleOnEmailChange
                }}
            />
        </Box>
    )
}

NewsletterSignUpFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string,
    otherProps: PropTypes.object
}

export default NewsletterSignUpFields
